import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';

const decimaPipe = new DecimalPipe('es-CL');
@Pipe({ name: 'checkNumberPipe' })
export class CheckNumberPipe implements PipeTransform {
  transform(value: string): string {
    const exp = parseFloat(value);
    if (isNaN(exp)) {
      return value;
    }
    return decimaPipe.transform(value.replace(',', '.'));
  }
}

// tslint:disable-next-line: max-classes-per-file
@Pipe({ name: 'dateCustom' })
export class DateCustomPipe implements PipeTransform {
  transform(value: any, format = 'YYYY-MM-DD'): string {
    moment.locale('es-es');
    return moment(value, format).format('DD-MM-YYYY');
  }
}

// tslint:disable-next-line: max-classes-per-file
@Pipe({
  name: 'safe',
})
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Pipe({
  name: 'capitalize',
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
    return value;
  }
}
